import { render, staticRenderFns } from "./Svgupload.vue?vue&type=template&id=86abd056&"
import script from "./Svgupload.vue?vue&type=script&lang=js&"
export * from "./Svgupload.vue?vue&type=script&lang=js&"
import style0 from "./Svgupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports